<mat-drawer-container class="drawer-container" [hasBackdrop]="true">
    <mat-drawer class="drawer-sidenav" #drawer mode="over" position="end">
        <ng-container *ngIf="student">
            <search-sidenav [student]="student"></search-sidenav>
        </ng-container>
    </mat-drawer>
    <div class="example-sidenav-content">
        <mat-icon aria-hidden="false" *ngIf="student" style="float: right;cursor: pointer;margin-top: 10px;" color="primary" aria-label="Menu"
            (click)="drawer.toggle()">menu</mat-icon>
        <mat-tab-group #tabGroup [selectedIndex]="tabIndex">
             <mat-tab>
                <ng-template mat-tab-label>
                    STUDENT INFORMATION
                </ng-template>
                <ng-template matTabContent>
                    <student-athlete [selectedStudent]="student" [WriteAction]="WRITE_COMPLIANCE_STUDENT_ATHLETE_INFORMATION"></student-athlete>
                </ng-template>
            </mat-tab> 
            <ng-container *ngIf="student">
                <mat-tab>
                    <ng-template mat-tab-label>
                        CONTACT INFORMATION
                    </ng-template>
                    <ng-template matTabContent>
                        <br />
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <app-personaddress [student]="student" [WriteAction]="WRITE_COMPLIANCE_CONTACT_INFORMATION"></app-personaddress>
                        <app-personemail [student]="student" [WriteAction]="WRITE_COMPLIANCE_CONTACT_INFORMATION"></app-personemail>
                        <app-personphone [student]="student" [WriteAction]="WRITE_COMPLIANCE_CONTACT_INFORMATION"></app-personphone>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        INSTITUTION SEASON DATA
                    </ng-template>
                    <ng-template matTabContent>
                        <br />
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <sport-season [student]="student" [WriteEligibilityFields]="WRITE_COMPLIANCE_ELIGIBILITY_FIELDS" [WriteCompliance]="WRITE_COMPLIANCE_SEASON_DATA"></sport-season>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        TRANSFER SEASON DATA
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <transfer-history [WriteCompliance]="WRITE_COMPLIANCE_TRANSFER_SEASON_DATA"></transfer-history>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        SEASON SUMMARY
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <season-summary></season-summary>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        OFFICIAL VISIT
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <official-visit [WriteCompliance]="WRITE_COMPLIANCE_OFFICIAL_VISIT"></official-visit>
                    </ng-template>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        CORRESPONDENCE
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <correspondence></correspondence>
                    </ng-template>
                </mat-tab>
                <mat-tab #documentsTab>
                    <ng-template mat-tab-label>
                        DOCUMENTS
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <app-studentdocument [WriteAction]="WRITE_COMPLIANCE_DOCUMENTS"></app-studentdocument>
                    </ng-template>
                </mat-tab> 
                <mat-tab #notesTab>
                    <ng-template mat-tab-label>
                        NOTES
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <app-notes [WriteAction]="WRITE_COMPLIANCE_NOTES"></app-notes>
                    </ng-template>
                </mat-tab>
                <mat-tab #notesTab>
                    <ng-template mat-tab-label>
                        TRANSACTIONS
                    </ng-template>
                    <ng-template matTabContent>
                        <br>
                        <app-studentInfo [student]="student"></app-studentInfo>
                        <app-audit-trail></app-audit-trail>
                    </ng-template>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </div>
</mat-drawer-container>